export default {
  index: [
    {
      path: '/BillSchedule',
      component: resolve => require(['./BillScheduleIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/BillSchedule/_router.js